export const windowIsDefined = () => typeof window !== 'undefined';
